<div class="app-default-address plr-15" [ngClass]="{'plr-0':router.url.includes('/event/') || router.url.includes('/stream/')}" [hidden]="(shippingAddressList?.length == 0 || !showShippingForm) ">
    <h6 class="fs-16 mtb-5">Shipping Address</h6>
        <div class="col-12 add-block"
            [ngClass]="{'col-lg-5 d-inline-block':router.url.includes('/event/') || router.url.includes('/network-market/product-shipping/') || router.url.includes('/product-shipping/'),'selected-block':address?.defaultShippingAddress}"
            *ngFor="let address of shippingAddressList.slice(0 , shippingAddressList.length > 4 && !dispList.ship ? 4 : shippingAddressList.length)"
            [ngStyle]="{'border-color': address?.defaultShippingAddress ? settingsData?.font_secondary_color : '','background': settingsData?.form_bg_color,
            'color': settingsData?.font_secondary_color, 'font-family': settingsData?.font_family ? settingsData?.font_family : ''}">

            <div class="row">
                <div class="col-1">
                    <mat-radio-group class="example-radio-group" [ngClass]="{'address-checkbox': settingsData?.form_bg_primary_color}" name="defaultShippingAddress">
                        <mat-radio-button [value]="address?.id" [checked]="address.defaultShippingAddress" [style.--radio-border-color]="settingsData?.font_secondary_color"  [style.--radio-label-color]="settingsData?.font_secondary_color"
                            (click)="selectAddress('shipping',address)" class="mt-10"></mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="col-10 pt-10">
                    <ng-container *ngIf="!router.url.includes('/stream/') && !router.url.includes('/album/video/')">
                        <span class="fs-16">{{address?.name}}</span><br>
                        <span>{{address?.line1}},</span><br>
                        <span *ngIf="address?.line2">{{address?.line2}},<br></span>
                        <span>{{address?.city}}, {{address?.state}},</span><br>
                        <span>{{address?.country}}, {{address?.zip}}</span><br>
                        <span>{{address?.dial_code}} {{address?.mobile}}</span>
                    </ng-container>
                    <ng-container *ngIf="router.url.includes('/stream/') || router.url.includes('/album/video/')">
                        <span class="fs-16">{{address?.name}}</span><br>
                        <span>{{address?.line1}}, </span>
                        <span *ngIf="address?.line2">{{address?.line2}}, </span>
                        <span>{{address?.city}}, {{address?.state}},</span><br>
                        <span>{{address?.country}}, {{address?.zip}}, </span>
                        <span>{{address?.dial_code}} {{address?.mobile}}</span>
                    </ng-container>
                </div>
            </div>
        </div>
        <div *ngIf="shippingAddressList?.length > 4" class="col-12 col-md-10 pl-50 text-center">
            <button mat-flat-button class="flat-primary-button border-radius-5 m-3" (click)="showList('shipping')">Show
                {{!dispList.ship ? "More" : "Less"}}</button>
        </div>

    <div *ngIf="shippingAddressList?.length > 0" class="pbl-10">
        <mat-radio-group class="example-radio-group" [ngClass]="{'address-checkbox': settingsData?.form_bg_primary_color}" [(ngModel)]="newShippingAddress">
            <mat-radio-button value="test" (click)="newAddress('shipping')" class="mt-10" [style.--radio-border-color]="settingsData?.font_secondary_color"  [style.--radio-label-color]="settingsData?.font_secondary_color">
                <h6 class="fs-16 mb-0 mt-3 pl-5"
                [ngStyle]="{ 'color': settingsData?.font_secondary_color ? settingsData?.font_secondary_color : settingsData?.font_secondary_color , 'font-family': settingsData?.font_family ? settingsData?.font_family : ''}"
                >Add New Shipping Address</h6>
            </mat-radio-button>
        </mat-radio-group>
    </div>
</div>
<div class="app-default-address plr-15" [ngClass]="{'plr-0':router.url.includes('/event/') || router.url.includes('/stream/')}" [hidden]="billingAddressList?.length == 0 || isFreeTickets"
    [ngStyle]="{'background-color':(!router.url.includes('/place-order') && settingsData?.bg_secondary_color)? 
    settingsData?.bg_secondary_color:''}">
    <h6 class="fs-16 mtb-5"
        [ngClass]="{'pt-20':selectedTickets?.length == 1}"
        [ngStyle]="{ 'color': settingsData?.font_secondary_color ? settingsData?.font_secondary_color : settingsData?.font_secondary_color , 'font-family': settingsData?.font_family ? settingsData?.font_family : ''}">
        Billing Address</h6>
        <div class="col-12 add-block"
            [ngClass]="{'col-lg-5 d-inline-block':router.url.includes('/event/') || router.url.includes('/network-market/product-shipping/') || router.url.includes('/product-shipping/'),'selected-block':address?.defaultBillingAddress}"
            *ngFor="let address of billingAddressList.slice(0, billingAddressList.length > 0 && !dispList.billing ? 4 :billingAddressList.length)"
            [ngStyle]="{ 'background':settingsData.form_bg_color,'color': settingsData?.font_secondary_color,'font-family': settingsData?.font_family ? settingsData?.font_family : '',
            'border-color': address?.defaultBillingAddress ? settingsData?.font_secondary_color : ''}"
            >
            <div class="row">
                <div class="col-1">
                    <mat-radio-group class="example-radio-group" [ngClass]="{'address-checkbox': settingsData?.form_bg_primary_color}" name="defaultBillingAddress">
                        <mat-radio-button [value]="address?.id" [checked]="address.defaultBillingAddress" [style.--radio-border-color]="settingsData?.font_secondary_color"  [style.--radio-label-color]="settingsData?.font_secondary_color"
                            (click)="selectAddress('billing',address)" class="mt-10"></mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="col-10 pt-10">
                    <ng-container *ngIf="!router.url.includes('/stream/') && !router.url.includes('/album/video/')">
                        <span class="fs-16">{{address?.name}}</span><br>
                        <span>{{address?.line1}},</span><br>
                        <span *ngIf="address?.line2">{{address?.line2}},<br></span>
                        <span>{{address?.city}}, {{address?.state}},</span><br>
                        <span>{{address?.country}}, {{address?.zip}}</span><br>
                        <span>{{address?.dial_code}} {{address?.mobile}}</span>
                    </ng-container>

                    <ng-container *ngIf="router.url.includes('/stream/') || router.url.includes('/album/video/')">
                        <span class="fs-16">{{address?.name}}</span><br>
                        <span>{{address?.line1}}, </span>
                        <span *ngIf="address?.line2">{{address?.line2}}, </span>
                        <span>{{address?.city}}, {{address?.state}},</span><br>
                        <span>{{address?.country}}, {{address?.zip}}, </span>
                        <span>{{address?.dial_code}} {{address?.mobile}}</span>
                    </ng-container>
                </div>
            </div>
        </div>
        <div *ngIf="billingAddressList?.length > 4" class="col-12 col-md-10 pl-50 text-center">
            <button mat-flat-button class="flat-primary-button border-radius-5 m-3" (click)="showList('billing')">Show
                {{!dispList.billing ? "More" : "Less"}}</button>
        </div>
    <div 
        *ngIf="billingAddressList?.length > 0" class="pbl-10">
        <mat-radio-group class="example-radio-group" [ngClass]="{'address-checkbox': settingsData?.form_bg_primary_color}" [(ngModel)]="newBillingAddress">
            <mat-radio-button value="test" (click)="newAddress('billing')" class="mt-10" [style.--radio-border-color]="settingsData?.font_secondary_color"  [style.--radio-label-color]="settingsData?.font_secondary_color">
                <h6 class="fs-16 mb-0 mt-3 pl-5"
                [ngStyle]="{ 'color': settingsData?.font_secondary_color ? settingsData?.font_secondary_color : settingsData?.font_secondary_color , 'font-family': settingsData?.font_family ? settingsData?.font_family : ''}"
                >Add New Billing Address</h6>
            </mat-radio-button>
        </mat-radio-group>
    </div>
</div>